export const environment = {
  production: false,
  groupName: "--",
  BusinessUnit: "SOUTHERN AFRICA",
  apiUrl: "https://doa-sasbu-new-api-test.azure.chevron.com/api",
  scope: "https://doa-sasbu-test.azure.chevron.com/user_impersonation",
  histroyReportUrl: "https://app.powerbi.com/reportEmbed?reportId=bc537157-76f0-4abf-b863-a82329747572&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  logReportUrl: "https://app.powerbi.com/reportEmbed?reportId=8454348f-6eab-4917-87a0-b317ed5b6137&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  integrityReportUrl: "https://app.powerbi.com/reportEmbed?reportId=c93d6e0c-8932-488e-a56e-0ce32fdeb7ef&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  masterReportUrl: "https://app.powerbi.com/reportEmbed?reportId=306675be-6933-4b7a-9f56-29b4639267fe&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26"



};
